import React from "react";
import { Link } from "react-router-dom";
import { useClaims } from "../../auth/useClaims";
import { paths } from "../../../routes/paths";
import DashboardPeriodControl from "../../../components/common/DashboardPeriodControl";
import { DASHBOARD_WIDGETS } from "../widgets/registry";

// This page deliberately knows nothing about Collections/Petty Cash/LPO/
// Technical/etc - it only renders the greeting header and the widget
// registry (see widgets/registry.js). Adding, removing, or reordering a
// widget never touches this file - see the registry's own doc comment.
const Dashboard = () => {
  const { fullName, username, roles, branches, isAllBranches, mustChangePassword, isLoading } = useClaims();

  const hour = new Date().getHours();
  const greeting = hour < 12 ? "morning" : hour < 17 ? "afternoon" : "evening";

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Good {greeting}, {fullName || username}</h4>
              <h6>
                {roles?.join(", ") || "No roles assigned"} ·{" "}
                {isAllBranches ? "All branches" : branches?.join(", ") || "No branch access"}
              </h6>
            </div>
          </div>
        </div>

        {mustChangePassword && (
          <div className="alert alert-warning d-flex flex-wrap align-items-center justify-content-between gap-2" role="alert">
            <span>Your account has a temporary password. Please choose your own.</span>
            <Link to={paths.changePassword} className="btn btn-sm btn-warning">
              Change Password
            </Link>
          </div>
        )}

        {isLoading ? (
          <p>Loading your access...</p>
        ) : (
          <>
            <DashboardPeriodControl />
            <div className="row g-3">
              {DASHBOARD_WIDGETS.map(({ id, Component }) => (
                <Component key={id} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
